module.exports = __webpack_public_path__ + "d7934b3699c9c5a3573958c955dab326.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201604_Presse_AVANGA_SZ_197KB.jpg
// module id = 565
// module chunks = 0